import { Dispatch, SetStateAction } from "react";
import { useAppContext } from "../hooks/useAppContext";
import { getTranslation } from "../locales/getTranslation";
import FoldRight from "./SVGIcons/FoldRight";

type SignInButtonProps = {
  type?: string;
  className?: string;
  setOpenSettingsModal: Dispatch<SetStateAction<boolean>>;
};

const SignInOutButton = ({
  type,
  className,
  setOpenSettingsModal,
}: SignInButtonProps) => {
  const { brand, locale } = useAppContext();

  const handleSignInOut = () => {
    if (type === "Sign In") {
      if (import.meta.env.MODE === "prod") {
        window.location.href = encodeURI(
          `https://style.clo-set.com/account/signin?returnUrl=${window.location.href}`,
        );
      } else {
        window.location.href = encodeURI(
          `https://staging.clo-set.com/account/signin?returnUrl=${window.location.href}`,
        );
      }
      // window.location.href = encodeURI(
      //   `https://style.clo-set.com/account/signin?returnUrl=${window.location.href}`,
      // );
    } else {
      if (import.meta.env.MODE === "prod") {
        window.location.href = encodeURI(
          `https://style.clo-set.com/account/logout?returnUrl=${window.location.href}`,
        );
      } else {
        window.location.href = encodeURI(
          `https://staging.clo-set.com/account/logout?returnUrl=${window.location.href}`,
        );
      }
      // window.location.href = encodeURI(
      //   `https://style.clo-set.com/account/logout?returnUrl=${window.location.href}`,
      // );
    }
    setOpenSettingsModal(false);
  };

  return (
    <button
      className={`${className} group inline-flex h-7 w-full min-w-20 select-none items-center justify-center gap-1.5 rounded-[300px] px-3.5 outline outline-1 outline-offset-[-1px] outline-grayscale-opacity-blevel4 transition-colors hover:bg-blue-solid-blue6 hover:outline-0`}
      onClick={handleSignInOut}
    >
      <div className="inline-flex items-center justify-center gap-1.5">
        <FoldRight className="h-3 w-3 fill-grayscale-solid-g10 transition-colors group-hover:fill-white" />
        <span className="text-xs font-medium leading-none text-grayscale-solid-g10 transition-colors group-hover:text-white">
          {type === "Sign In"
            ? getTranslation(locale, "Sign In")
            : getTranslation(locale, "Sign Out")}
        </span>
      </div>
    </button>
  );
};

export default SignInOutButton;
